/**
 * Ticket SK5: Serverfunktionen der öffentlichen Kursseiten.
 *
 * Bewusst unauthentifiziert (Besucher sind nicht angemeldet), ausschließlich
 * lesend und mit fester Feldauswahl im Server-Teil.
 */

import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { coursePublicSlugSchema } from "@/lib/courses-public";

export const listPublicCourses = createServerFn({ method: "GET" }).handler(async () => {
  const { listPublicCoursesOnServer } = await import("@/lib/courses-public.server");
  return listPublicCoursesOnServer();
});

export const getPublicCourse = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) =>
    z.object({ slug: coursePublicSlugSchema }).parse(data),
  )
  .handler(async ({ data }) => {
    const { getPublicCourseOnServer } = await import("@/lib/courses-public.server");
    return getPublicCourseOnServer(data.slug);
  });
